export default __webpack_public_path__ + "static/media/accordion_open.fef13d92.svg";